import { useMemo } from "react";

export const useQueryParams = (defaultData= {}) => {

  const queryParams = useMemo(() => {

    var pairs = window.location.search.slice(1).split('&');
    var result = {};
    pairs.forEach(pair => {
      pair = pair.split('=');
      result[pair[0]] = decodeURIComponent(pair[1] || '');
    });

    return {
      ...defaultData,
      ...JSON.parse(JSON.stringify(result))
    }
  
  }, [defaultData])

  return queryParams
}